export const TOGGLE_DEV_MODE = 'TOGGLE_DEV_MODE' // todo(egor): move to plugin

export const AUTH_UPDATE_RETURN_URL = 'AUTH_UPDATE_RETURN_URL'

export const WALLDASH_INIT = 'WALLDASH_INIT'
export const WALLDASH_CHANGE_SCREEN = 'WALLDASH_CHANGE_SCREEN'
export const WALLDASH_STATS_INIT = 'WALLDASH_STATS_INIT'
export const WALLDASH_STATS_CHANGE_PROGRESS = 'WALLDASH_STATS_CHANGE_PROGRESS'
export const WALLDASH_STATS_LOAD_DATA = 'WALLDASH_STATS_LOAD_DATA'

export const DASHBOARD_CHANGE_ABD_DATES = 'DASHBOARD_CHANGE_ABD_DATES'
export const DASHBOARD_CHANGE_ABD_CASE_ORIGIN = 'DASHBOARD_CHANGE_ABD_CASE_ORIGIN'
export const DASHBOARD_CHANGE_ABD_PROGRESS = 'DASHBOARD_CHANGE_ABD_PROGRESS'
export const DASHBOARD_LOAD_ABD_DATA = 'DASHBOARD_LOAD_ABD_DATA'

export const DASHBOARD_CHANGE_RBD_DATES = 'DASHBOARD_CHANGE_RBD_DATES'
export const DASHBOARD_CHANGE_RBD_CASE_ORIGIN = 'DASHBOARD_CHANGE_RBD_CASE_ORIGIN'
export const DASHBOARD_CHANGE_RBD_PROGRESS = 'DASHBOARD_CHANGE_RBD_PROGRESS'
export const DASHBOARD_LOAD_RBD_DATA = 'DASHBOARD_LOAD_RBD_DATA'

export const DASHBOARD_CHANGE_CVM_PROGRESS = 'DASHBOARD_CHANGE_CVM_PROGRESS'
export const DASHBOARD_LOAD_CVM_DATA = 'DASHBOARD_LOAD_CVM_DATA'

export const COMMON_LOAD_INITIAL_DATA = 'COMMON_LOAD_INITIAL_DATA'
export const COMMON_LOAD_INITIAL_DATA_SUCCESS = 'COMMON_LOAD_INITIAL_DATA_SUCCESS'
export const COMMON_LOAD_INITIAL_DATA_FAILED = 'COMMON_LOAD_INITIAL_DATA_FAILED'

export const SERVICE_GROUP_CREATE = 'SERVICE_GROUP_CREATE'
export const SERVICE_GROUP_UPDATE = 'SERVICE_GROUP_UPDATE'
export const SERVICE_GROUP_DELETE = 'SERVICE_GROUP_DELETE'

export const CASE_FETCH_BY_ID = 'CASE_FETCH_BY_ID'
export const CASE_FETCHED_BY_ID_SUCCESS = 'CASE_FETCHED_BY_ID_SUCCESS'
export const CASE_FETCHED_BY_ID_FAILED = 'CASE_FETCHED_BY_ID_FAILED'

export const ANALYTICS_FETCH = 'ANALYTICS_FETCH'
export const ANALYTICS_FETCH_SUCCESS = 'ANALYTICS_FETCH_SUCCESS'
export const ANALYTICS_FETCH_FAILED = 'ANALYTICS_FETCH_FAILED'
export const ANALYTICS_FETCH_BY_CASE_SUCCESS = 'ANALYTICS_FETCH_BY_CASE_SUCCESS'
export const ANALYTICS_FETCH_BY_CASE_FAILED = 'ANALYTICS_FETCH_BY_CASE_FAILED'
export const ANALYTICS_CHANGE_FILTER = 'ANALYTICS_CHANGE_FILTER'
export const ANALYTICS_CHANGE_CLIENT_FILTER = 'ANALYTICS_CHANGE_CLIENT_FILTER'

export const INVOICE_FILTERED_FETCH = 'INVOICE_FILTERED_FETCH';
export const INVOICE_FILTERED_FETCH_SUCCESS = 'INVOICE_FILTERED_FETCH_SUCCESS';
export const INVOICE_FILTERED_FETCH_FAILED = 'INVOICE_FILTERED_FETCH_FAILED';
export const INVOICE_CHANGE_FILTER = 'INVOICE_CHANGE_FILTER';
export const INVOICE_FETCH_BY_ID = 'INVOICE_FETCH_BY_ID';
export const INVOICE_FETCH_BY_ID_SUCCESS = 'INVOICE_FETCH_BY_ID_SUCCESS';
export const INVOICE_FETCH_BY_ID_FAILED = 'INVOICE_FETCH_BY_ID_FAILED';
export const INVOICE_FETCH_INVOICE_LOG_CANDIDATES = 'INVOICE_FETCH_INVOICE_LOG_CANDIDATES';
export const INVOICE_FETCH_INVOICE_LOG_CANDIDATES_SUCCESS = 'INVOICE_FETCH_INVOICE_LOG_CANDIDATES_SUCCESS';
export const INVOICE_FETCH_INVOICE_LOG_CANDIDATES_FAILED = 'INVOICE_FETCH_INVOICE_LOG_CANDIDATES_FAILED';
export const INVOICE_CHANGE_FILTER_FOR_INVOICE_LOG_CANDIDATES = 'INVOICE_CHANGE_FILTER_FOR_INVOICE_LOG_CANDIDATES';
export const INVOICE_CHANGE_CLIENT_FILTER_FOR_INVOICE_LOG_CANDIDATES = 'INVOICE_CHANGE_CLIENT_FILTER_FOR_INVOICE_LOG_CANDIDATES';
export const INVOICE_UPDATE_CASE_INFO_IN_INVOICE_SUCCESS = 'INVOICE_UPDATE_CASE_INFO_IN_INVOICE_SUCCESS';
export const INVOICE_UPDATE_CASE_INFO_IN_INVOICE_FAILED = 'INVOICE_UPDATE_CASE_INFO_IN_INVOICE_FAILED';


export const CASE_SERVICE_LOG_FETCH_BY_CASE = 'CASE_SERVICE_LOG_FETCH_BY_CASE'
export const CASE_SERVICE_LOG_FETCH_BY_CASE_SUCCESS = 'CASE_SERVICE_LOG_FETCH_BY_CASE_SUCCESS'
export const CASE_SERVICE_LOG_FETCH_BY_CASE_FAILED = 'CASE_SERVICE_LOG_FETCH_BY_CASE_FAILED'

export const CONTRACTORS_CREATE = 'CONTRACTORS_CREATE'
export const CONTRACTORS_UPDATE = 'CONTRACTORS_UPDATE'
export const CONTRACTORS_DELETE = 'CONTRACTORS_DELETE'

export const METADATA_FETCH = 'METADATA_FETCH';
export const METADATA_FETCH_SUCCESS = 'METADATA_FETCH_SUCCESS';
export const METADATA_FETCH_FAILED = 'METADATA_FETCH_FAILED';

export const LABORATORY_CREATE = 'LABORATORY_CREATE'
export const LABORATORY_UPDATE = 'LABORATORY_UPDATE'
export const LABORATORY_DELETE = 'LABORATORY_DELETE'

export const REACTION_CREATE = 'REACTION_CREATE'
export const REACTION_UPDATE = 'REACTION_UPDATE'
export const REACTION_DELETE = 'REACTION_DELETE'

export const STAIN_CREATE = 'STAIN_CREATE'
export const STAIN_UPDATE = 'STAIN_UPDATE'
export const STAIN_DELETE = 'STAIN_DELETE'

export const SLIDE_SERVICE_CREATE = 'SLIDE_SERVICE_CREATE'
export const SLIDE_SERVICE_UPDATE = 'SLIDE_SERVICE_UPDATE'
export const SLIDE_SERVICE_DELETE = 'SLIDE_SERVICE_DELETE'

export const COST_CENTERS_LOAD_DATA = 'COST_CENTERS_LOAD_DATA'
export const COST_CENTERS_LOAD_DATA_SUCCESS = 'COST_CENTERS_LOAD_DATA_SUCCESS'
export const COST_CENTERS_LOAD_DATA_FAILED = 'COST_CENTERS_LOAD_DATA_FAILED'
export const COST_CENTERS_CREATION_DATA_SUCCESS = 'COST_CENTERS_CREATION_DATA_SUCCESS'
export const COST_CENTERS_UPDATE_DATA_SUCCESS = 'COST_CENTERS_UPDATE_DATA_SUCCESS'
export const COST_CENTERS_DELETE_DATA_SUCCESS = 'COST_CENTERS_DELETE_DATA_SUCCESS'

export const REGIONS_LOAD_DATA = 'REGIONS_LOAD_DATA'
export const REGIONS_LOAD_DATA_SUCCESS = 'REGIONS_LOAD_DATA_SUCCESS'
export const REGIONS_LOAD_DATA_FAILED = 'REGIONS_LOAD_DATA_FAILED'

export const FETCH_DP_URL = 'FETCH_DP_URL'



// WEBPACK FOOTER //
// ./src/store/mutations/available.js